export default function Logo({ inverted = false, height = 32 }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo.svg`}
      alt="OneLedger"
      height={height}
      style={{
        display: 'block',
        filter: inverted ? 'brightness(0) invert(1)' : 'none',
      }}
    />
  );
}
